import { ApolloClient } from '@apollo/client'

import { cache } from './cache'
import { link } from './link'

export * from './types'

const client = new ApolloClient({
  link,
  cache,
  connectToDevTools: process.env.NODE_ENV === 'development',
})

export { client, cache, link }
